module.exports = __webpack_public_path__ + "static/media/whatsapp.5ea27d48.svg";